import React from 'react';
import { HandleUserSelection } from 'containers/HandlesPanel/types';
import DrawersHandlesColorPicker from 'containers/HandlesPanel/DrawersHandleSubPanel/DrawersHandlesColorPicker';
import { useDispatch, useSelector } from 'react-redux';
import { restoreCabinet } from 'containers/Configurator/actions/furniture';
import { Cabinet } from 'lib/modelBuilder/entities/Cabinet';
import { createStructuredSelector } from 'reselect';
import { RootState } from 'containers/PanesPanel/types';
import { makeSelectLastHistoryCabinet } from 'containers/Configurator/selectors/history';
import OthersHandlePicker from 'containers/HandlesPanel/DrawersHandleSubPanel/OthersHandlePicker';
import { makeSelectIsHandlesMode } from '../../ModeBar/selectors';

interface Props {
  handlePositionSelected: HandleUserSelection[];
}

interface StateProps {
  lastHistoryCabinet: Cabinet;
  isPaintHandlesMode: boolean;
}

const stateSelector = createStructuredSelector<RootState, StateProps>({
  lastHistoryCabinet: makeSelectLastHistoryCabinet(),
  isPaintHandlesMode: makeSelectIsHandlesMode(),
});

const DrawersHandleSubPanel = ({ handlePositionSelected }: Props) => {
  const dispatch = useDispatch();
  const { lastHistoryCabinet, isPaintHandlesMode } = useSelector(stateSelector);

  const onLeave = () => {
    // Restore the last history element
    dispatch(restoreCabinet(lastHistoryCabinet));
  };

  function shouldDisplay() {
    if (isPaintHandlesMode) return true;
    if (handlePositionSelected.includes('Drawers')) return true;
    if (handlePositionSelected.length > 0) {
      return typeof handlePositionSelected[0] === 'number';
    }
  }

  if (shouldDisplay()) {
    return (
      <div className="flex">
        <DrawersHandlesColorPicker />
      </div>
    );
  } else return null;
};

export default DrawersHandleSubPanel;
